import React from 'react';
import DatePicker from './DatePicker';

interface DashboardCardProps {
  icon: string;
  title: string;
  number: string | number;
  columns: number;
  growthPercent: string;
  showDateFilter?: boolean;
  selectedDate?: Date;
  onDateChange?: (date: Date | undefined) => void;
}

const DashboardCard: React.FC<DashboardCardProps> = ({
  icon,
  title,
  number,
  columns,
  showDateFilter,
  selectedDate,
  onDateChange,
}) => {
  return (
    <div
      className={`${columns === 2 && 'md:col-span-2'} bg-white border border-gray-200 rounded-xl px-5 py-4 w-full shadow-sm hover:shadow-md transition-shadow duration-200`}
    >
      <div className="mb-3 flex items-center justify-between flex-wrap gap-1">
        <div className="w-10 h-10 flex items-center justify-center bg-gray-100 rounded-lg border border-gray-200">
          <img src={icon} alt={title} className="w-5 h-5" />
        </div>

        {showDateFilter && onDateChange && (
          <DatePicker value={selectedDate} onChange={onDateChange} />
        )}
      </div>
      <h2 className="text-gray-900 text-2xl font-bold tracking-tight mb-0.5">{number}</h2>
      <p className="text-gray-500 text-sm font-medium">{title}</p>
    </div>
  );
};

export default DashboardCard;
